import React from "react";
import data from "../Data/Data";
import Btn from "../../../ReUseAbleComp/Button.jsx";
import Header from "../../../ReUseAbleComp/Header.jsx";
import Search from "../../../ReUseAbleComp/SearchInput.jsx";
import useSpeechToText from "react-hook-speech-to-text";
import { FaMicrophone, FaMicrophoneSlash } from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
function LGEnglish({
  searchTag,
  CovidsearchTerm,
  setCovidSearchTerm,
  CovidsearchResults,
  handleCovidChange,
}) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  let {
    error,
    isRecording,
    results,
    startSpeechToText,
    stopSpeechToText,
  } = useSpeechToText({
    crossBrowser: true,
    continuous: false,
    useLegacyResults: false,
    timeout: 1000,
  });
  React.useEffect(() => {
    if (results.length) {
      setCovidSearchTerm(results[results.length - 1].transcript);
    }
  }, [results]);
  const hadleVoiceSearch = () => {
    //  isRecording ? stopSpeechToText : startSpeechToText;
    if (isRecording) {
      stopSpeechToText();
    } else {
      startSpeechToText();
    }
    toast.info("Voice Search Started", {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      pauseOnHover: false,
      closeOnClick: true,
      draggable: false,
      progress: undefined,
    });
  };

  if (error) return <p>Web Speech API is not available in this browser 🤷‍</p>;

  return (
    <>
      <Header
        open={open}
        setOpen={setOpen}
        handleOpen={handleOpen}
        handleClose={handleClose}
      />
      <br />
      <br />
      <br />
      <br />
      <center>
        <h1>Covid-19</h1>
        <Search
          handleChange={handleCovidChange}
          searchTerm={CovidsearchTerm}
          searchTag={searchTag}
        />
        {/* {!isRecording ? (
          <FaMicrophone
            style={{
              position: "absolute",
              right: "10%",
              top: "28%",
              fontSize: "30px",
            }}
            onClick={() => {
              hadleVoiceSearch();
            }}
          />
        ) : (
          <FaMicrophoneSlash
            style={{
              position: "absolute",
              right: "10%",
              top: "28%",
              fontSize: "30px",
            }}
          />
        )} */}
        {CovidsearchResults.map((item) => (
          <Btn
            key={item.id}
            title={item.title}
            id={item.RID}
            path={`/CovidEngTopicsDetails/${item.id}`}
          />
        ))}
      </center>
    </>
  );
}

export default LGEnglish;
